import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-list/[id]/page.client.tsx");
